<template>
  <div id="main-wrapper" :dir="$i18n.locale == 'ar'? 'rtl':'ltr'">

    <NavbarLight />

    <div class="image-cover hero-banner" :style="{ background: `url(${bg}) no-repeat`, backgroundSize: 'cover' }" data-overlay="6">
      <div class="container">
        <h1 class="big-header-capt mb-0">{{ t('Search for what you want here') }}</h1>
        <p class="text-center mb-5">{{ t('You will find all professionals and services at your fingertips.') }}</p>
        <FormTwo />
      </div>
    </div>
    <!-- Top Ads Carousel -->
    <!-- <section class="bg-light section-padding-top-ad">
    <div class="container">
        <div class="top-ads-carousel">
        <div class="carousel-track-manual">
            <div
            v-for="(ad, index) in visibleTopAds"
            :key="'top-ad-' + index"
            class="carousel-slide-manual"
            @click="openAd(ad.link)"
            >
            <img :src="ad.image" alt="Top Ad" class="carousel-image" />
            </div>
        </div>
        <div class="carousel-dots">
            <span
            v-for="(dot, index) in totalDots"
            :key="'dot-' + index"
            class="carousel-dot"
            :class="{ active: currentSlide === index }"
            @click="currentSlide = index"
            ></span>
        </div>
        </div>
    </div>
    </section>  -->
    <section class="bg-light section-padding-top-ad">
    <div class="container">
        <!-- <div
        v-for="(ad, index) in topAds"
        :key="'top-ad-' + index"
        class="ad-container"
        @click="openAd(ad.link)"
        >
        <img :src="ad.image" alt="Top Ad" class="top-image" />
        </div> -->
        <div
          v-for="(ad, index) in topAds"
          :key="'top-ad-' + index"
          class="ad-container"
        >
          <router-link
            v-if="ad.link_type === 'internal' && ad.provider_id"
            :to="`/service-provider/show-details/${ad.provider_id}`"
            target="_blank"
            rel="noopener noreferrer"
            class="block"
          >
            <img :src="ad.image" alt="Top Ad" class="top-image" />
          </router-link>

          <a
            v-else
            :href="ad.link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img :src="ad.image" alt="Top Ad" class="top-image" />
          </a>
        </div>

    </div>
    </section>


    <section class="bg-light section-padding">
        <div class="container mt-5 mb-5">
            <div class="row">
                <!-- Right Column (col-2) -->
                <div class="col-lg-2 col-md-12">
                    <div class="p-3 bg-light col-margin">
                        <div class="sidebar-widgets">                
                            <h6>{{$t('Featured service providers')}}</h6>                
                            <div class="sidebar_featured_property">
                                <div class="vertical-marquee-container">
                                    <div class="vertical-marquee-content" :style="{ animationDuration: marqueeDuration }">
                                        <div
                                        v-for="(provider, index) in featuredProviders"
                                        :key="index"
                                        class="vertical-marquee-item flex items-center gap-2"
                                        >
                                            <UserIcon class="w-5 h-5 text-primary" />
                                            <router-link
                                                :to="`/service-provider/show-details/${provider.id}`"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {{ provider.name }}&nbsp; ({{ provider.category.name }})
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br>

                        <div class="sidebar-widgets mt-4">
                            <h6 class="mb-3">{{$t('Visitors Count')}}</h6>
                            <div class="text-center border rounded p-2 bg-white shadow-sm">
                                <a 
                                href="https://info.flagcounter.com/Oo4Z"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="View detailed visitor flag statistics"
                                >
                                <img
                                    src="https://s01.flagcounter.com/countxl/Oo4Z/bg_FFFFFF/txt_000000/border_74BF44/columns_1/maxflags_7/viewers_0/labels_1/pageviews_1/flags_1/percent_0/"
                                    alt="Visitor Flag Counter"
                                    class="img-fluid"
                                    style="max-width: 100%; height: auto;"
                                />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-8 col-md-12">
                    <section class="bg-light section-padding">
                        <!-- Featured Providers -->
                        <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-xl-6 col-lg-7 col-md-10 text-center">
                            <div class="sec-heading center">
                                <h2>{{ t('Featured Providers') }}</h2>
                                <p>{{ t('A group of the most skilled professionals in various fields come together in one place to offer their services with ease to all users.') }}</p>
                            </div>
                            </div>
                        </div>
                        <GridTwo />
                        <div class="row align-items-center justify-content-center">
                            <div class="col-lg-12 text-center mt-5">
                            <router-link to="/grid" class="btn btn-primary px-md-5 rounded">
                                {{ $t('Browse More') }}
                            </router-link>
                            </div>
                        </div>
                        </div>
                    </section>

                    <section class="section-padding">
                        <!-- Important Professions -->
                        <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-7 text-center">
                            <div class="sec-heading center mb-4">
                                <h2>{{ t('The most important professions') }}</h2>
                                <p>{{ t('We provide you with all the services you might need in your home or workplace, delivered by skilled professionals and essential service providers.') }}</p>
                            </div>
                            </div>
                        </div>
                            <div class="categories-row mt-3">
                            <div v-for="(item, index) in categories" :key="index" class="category-item">
                                <div class="classical-cats-wrap">
                                <a class="classical-cats-boxs">
                                    <div class="classical-cats-icon px-2 py-2 rounded" :class="item.bg">
                                    <img :src="item.icon" alt="Category" style="width: 100px; height: 100px; object-fit: contain;" />
                                    </div>
                                    <div class="classical-cats-wrap-content">
                                    <h4>{{ item.name }}</h4>
                                    </div>
                                </a>
                                </div>
                            </div>
                            </div>
                        </div>
                    </section>

                    <section class="bg-light section-padding">
                        <!-- Latest Providers -->
                        <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-xl-6 col-lg-7 col-md-10 text-center">
                            <div class="sec-heading center">
                                <h2>{{ t('Latest Providers') }}</h2>
                                <p>{{ t('Here, you will find a complete world of professionals in various fields within a space that makes it easy for you to connect with them.') }}</p>
                            </div>
                            </div>
                        </div>
                        <GridOne />
                        <div class="row align-items-center justify-content-center">
                            <div class="col-lg-12 text-center mt-5">
                            <router-link to="/grid" class="btn btn-primary px-md-5 rounded">
                                {{ $t('Browse More') }}
                            </router-link>
                            </div>
                        </div>
                        </div>
                    </section>

                    <section class="gray-bg section-padding">
                        <!-- How It Works -->
                        <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-xl-6 col-lg-7 col-md-10 text-center">
                            <div class="sec-heading center">
                                <h2>{{ t('How can you benefit from the platform?') }}</h2>
                            </div>
                            </div>
                        </div>
                        <HowItsWork />
                        </div>
                    </section>

                    <section class="bg-light section-padding">
                        <!-- Customer Reviews -->
                        <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-7 col-md-10 text-center">
                            <div class="sec-heading center">
                                <h2>{{ t('Customer reviews') }}</h2>
                            </div>
                            </div>
                        </div>
                        <ClientOne />
                        </div>
                    </section>

                    <section class="section-padding">
                        <!-- Achievement -->
                        <div class="container">
                            <div class="row justify-content-center">
                                <div class="col-lg-7 text-center">
                                <div class="sec-heading center mb-4">
                                    <h2>{{ t('Achievement') }}</h2>
                                    <p>{{ t('What we have achieved is not just numbers, but the result of effort we are proud of, and it drives us toward further development and progress.') }}</p>
                                </div>
                                </div>
                            </div>
                            <AchievementCounter />
                        </div>
                    </section>
                </div>

                <!-- Left Column (col-2) -->
                <div class="col-lg-2 col-md-12">
                    <div class="p-3 bg-light col-margin">
                        <div v-if="sidebarAds.length === 0">{{ t('No ads to display.') }}</div>
                        <div v-else>
                        <div
                          v-for="(ad, index) in sidebarAds"
                          :key="index"
                          class="mb-3"
                          style="cursor: pointer;"
                        >
                          <!-- Internal link -->
                          <router-link
                            v-if="ad.link_type === 'internal' && ad.provider_id"
                            :to="`/service-provider/show-details/${ad.provider_id}`"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="block"
                          >
                            <img
                              :src="ad.image"
                              alt="Ad Image"
                              class="img-fluid rounded"
                              style="width: 100%; object-fit: contain;"
                            />
                          </router-link>

                          <!-- External link -->
                          <a
                            v-else
                            :href="ad.link"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              :src="ad.image"
                              alt="Ad Image"
                              class="img-fluid rounded"
                              style="width: 100%; object-fit: contain;"
                            />
                          </a>
                        </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
    <!-- Footer -->
    <FooterTop :bg="'theme-bg'" />
    <FooterDark />
    <ScrollToTop />
  </div>
</template>


<script setup>
    import bg from '@/assets/img/banner-8.jpg'
    import FooterDark from '@/components/footer/footer-dark.vue';
    import FooterTop from '@/components/footer/footer-top.vue';
    import FormTwo from '@/components/form/form-two.vue';
    import HowItsWork from '@/components/how-its-work.vue';
    import NavbarLight from '@/components/navbar/navbar-light.vue';
    import GridOne from '@/components/property/grid-one.vue';
    import GridTwo from '@/components/property/grid-two.vue';
    import ScrollToTop from '@/components/scroll-to-top.vue';
    import { ref ,onMounted,computed,watch} from "vue";
    import { useI18n } from "vue-i18n";
    import ClientOne from '@/components/client-one.vue';
    import AchievementCounter from '@/components/achievement-counter.vue';
    import axios from "axios";
    import { UserIcon } from '@heroicons/vue/24/outline'
    const { t } = useI18n();
    const categories = ref([]);
    const { locale } = useI18n();
    const fetchCategories = async () => {
    try {
        const response = await axios.get("/get-trending-categories", {
                headers: {
                    'locale': locale.value
                }
            });

        if (response.data && Array.isArray(response.data.categories)) {
        categories.value = response.data.categories;
        } else {
        console.error("Unexpected response format for categories:", response.data);
        }
    } catch (error) {
        console.error("Error fetching categories:", error);
    }
    };

    const sidebarAds = ref([]);
    const topAds = ref([]);

    const fetchAds = async () => {
    try {
        const response = await axios.get('/get-ads?type=web');
        if (response.data && Array.isArray(response.data.ads)) {
        const filteredAds = response.data.ads.filter(ad => ad.show_home === true);
        sidebarAds.value = filteredAds.filter(ad => ad.place === 'sidebar_ad');
        topAds.value = filteredAds.filter(ad => ad.place === 'top_ad');
        } else {
        console.error('Unexpected response format for ads:', response.data);
        }
    } catch (error) {
        console.error('Error fetching ads:', error);
    }
    };

    const featuredProviders = ref([])
    const fetchFeaturedProviders = async () => {
    try {
        const res = await axios.get("/users/list-service-provider-without-paginate?featured=featured", {
            headers: {
                'locale': locale.value
            }
        });

        featuredProviders.value = res.data.service_providers;


    } catch (error) {
        console.error('Error fetching featured providers:', error);
    }
    };

    const marqueeDuration = computed(() => {
      const count = featuredProviders.value.length;
      if (count === 0) return "30s"; 
      return `${count * 5}s`;
    });
    // const currentSlide = ref(0);
    // const visibleTopAds = computed(() => {
    // return topAds.value.slice(currentSlide.value, currentSlide.value + 3);
    // });
    // const totalDots = computed(() => {
    // return topAds.value.length > 3
    //     ? topAds.value.length - 2
    //     : 1;
    // });
    // const openAd = (url) => {
    // window.open(url, '_blank');
    // };
    onMounted(() => {
    fetchCategories();
    fetchAds();
    fetchFeaturedProviders();
    });
    watch(locale, () => {
    fetchCategories();
    fetchAds();
    fetchFeaturedProviders();
    });
</script>
<style scoped>
.img-fluid-2 {
  max-width: 100%;
  height: 222px;
}
h6{
    line-height: 20px;
    font-size: 14px;
}
.section-padding{
    padding: 20px 0 20px;
}
.section-padding-top-ad{
    padding: 20px 0 1px;
}
.vertical-marquee-container {
  height: 150px;
  overflow: hidden;
  background: #fff;
  border-radius: 8px;
  position: relative;
}

.vertical-marquee-content {
  display: flex;
  flex-direction: column;
  animation: scroll-up linear infinite;
}

.vertical-marquee-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 5px;
  font-weight: bold;
  font-size: 0.7em;
  color: #333;
}
/* Animation */
@keyframes scroll-up {
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(-50%);
  }
}
.col-margin{
    margin-top: 145px;
}

@media (max-width: 768px) {
  .col-margin {
    margin-top: -73px;
  }
}
.top-ads-carousel {
  background: #eff4fc;
  border-radius: 8px;
  padding: 10px;
  overflow: hidden;
  position: relative;
}

.carousel-track-manual {
  display: flex;
  gap: 10px;
  transition: transform 0.5s ease;
}

.carousel-slide-manual {
  flex: 1 1 calc(33.33% - 10px);
  overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
}

.carousel-image {
  width: 100%;
  height: 190px;
  object-fit: contain;
  display: block;
  border-radius: 8px;
  transition: transform 0.3s ease;
}

.carousel-slide-manual:hover .carousel-image {
  transform: scale(1.05);
}

.carousel-dots {
  text-align: center;
  margin-top: 10px;
}

.carousel-dot {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin: 0 5px;
  background-color: #ccc;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.carousel-dot.active {
  background-color: #74BF44;
}

.top-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  border-radius: 8px;
  transition: transform 0.3s ease;
  position: relative;
  z-index: 1;
}

.ad-container {
  margin-bottom: 20px;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  border-radius: 8px;
}

.ad-container::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 8px;
  z-index: 2;
}

.ad-container:hover::after {
  opacity: 1;
}

.categories-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
}

.category-item {
  flex: 0 0 20%;
  max-width: 18%;
  box-sizing: border-box;
  text-align: center;
}

@media (max-width: 1200px) {
  .category-item {
    flex: 0 0 25%; 
    max-width: 25%;
  }
}

@media (max-width: 992px) {
  .category-item {
    flex: 0 0 33.33%; 
    max-width: 33.33%;
  }
}

@media (max-width: 768px) {
  .category-item {
    flex: 0 0 50%; 
    max-width: 50%;
  }
}

@media (max-width: 576px) {
  .category-item {
    flex: 0 0 100%; 
    max-width: 100%;
  }
}


</style>